module.exports = __webpack_public_path__ + "img/yuanpan.51b2e4f4.png";